module.exports = __webpack_public_path__ + "static/media/different-equation-box-bg.68c7ff62.webp";